import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { HelpIndexComponent } from './help-index.component';
import { TranslocoModule } from '@ngneat/transloco';
import { SharedPipeModule } from '../pipes/shared-pipe.module';

@NgModule({
  imports: [
    CommonModule,
    MatStepperModule,
    MatListModule,
    MatIconModule,
    MatCardModule,
    FlexLayoutModule,
    MatButtonModule,
    TranslocoModule,
    SharedPipeModule
  ],
  declarations: [
    HelpIndexComponent
  ],
  exports: [HelpIndexComponent]
})
export class HelpIndexModule { }
